import { BookOpen, ArrowLeft, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function DocumentationPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-xl text-center">
        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour au tableau de bord
        </Link>

        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-emerald-500/20 to-sky-500/20 border border-emerald-500/20 mb-6">
          <BookOpen className="w-10 h-10 text-emerald-400" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-white mb-3">
          Documentation
        </h1>

        {/* Description */}
        <p className="text-zinc-400 text-sm mb-8 max-w-md mx-auto">
          Notre documentation complète est en cours de rédaction. 
          Elle sera bientôt disponible pour vous aider à tirer le meilleur parti de Totemium.
        </p>

        {/* Coming soon badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-medium mb-8">
          <span className="h-2 w-2 rounded-full bg-amber-400 animate-pulse" />
          Bientôt disponible
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-6 py-2.5 text-sm font-semibold text-white hover:bg-emerald-600 transition-colors"
          >
            Nous contacter
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-zinc-800 px-6 py-2.5 text-sm font-semibold text-zinc-300 hover:bg-zinc-700 hover:text-white transition-colors"
          >
            Retour à l'accueil
          </Link>
        </div>

        {/* Placeholder sections */}
        <div className="mt-16 grid gap-4 sm:grid-cols-3 text-left">
          {[
            { title: 'Premiers pas', desc: 'Guide de démarrage rapide' },
            { title: 'API Reference', desc: 'Documentation technique' },
            { title: 'Tutoriels', desc: 'Guides pas à pas' },
          ].map((section, i) => (
            <div
              key={i}
              className="p-4 rounded-xl bg-zinc-900/50 border border-zinc-800 opacity-50"
            >
              <h3 className="text-sm font-semibold text-zinc-300 mb-1">{section.title}</h3>
              <p className="text-xs text-zinc-500">{section.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
